import jwtAuthAxios from "../../../services/jwtAuth";
import { createSlice, createAsyncThunk, createEntityAdapter } from '@reduxjs/toolkit';

export const getAll = createAsyncThunk("mapPeriodeDaftar/getAll", async() => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`v1/master/map/user-periode-daftar`);
    return response.data;
});

export const getById = createAsyncThunk("mapPeriodeDaftar/getById", async(val) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`v1/master/map/user-periode-daftar/${val}`);
    return response.data;
});

export const update = createAsyncThunk("mapPeriodeDaftar/update", async(val) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.put(`v1/master/map/user-periode-daftar`,val);
    return response.data;
});

export const save = createAsyncThunk("mapPeriodeDaftar/save", async(val) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.post(`v1/master/map/user-periode-daftar`,val);
    return response.data;
});


export const findByUserId = createAsyncThunk("mapPeriodeDaftar/findByUserId", async(val) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.post(`v1/master/map/user-periode-daftar/user`,val);
    return response.data;
});

export const remove = createAsyncThunk("mapPeriodeDaftar/remove", async(val) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.delete(`v1/master/map/user-periode-daftar/${val}`);
    return response.data;
});

const initialState = {
    loading : false,
    data : {},
    dataList : []
}

const mapPeriodeDaftarSlice=createSlice ( {
                                                name : "mapPeriodeDaftarSlice" , initialState : initialState , extraReducers : {
        [ findByUserId.pending ] : ( state , action ) => {
            state.loading = true;
        } ,
        [ findByUserId.fulfilled ] : ( state , action ) => {
            state.data = action.payload;
            state.loading = false;
        } ,
        [ findByUserId.rejected ] : ( state , action ) => {
            state.loading = false;
        } ,

        [ getAll.pending ] : ( state , action ) => {
            state.loading=true;
        } ,
        [ getAll.fulfilled ] : ( state , action ) => {
            state.dataList=action.payload;
            state.loading=false;
        } ,
        [ getAll.rejected ] : ( state , action ) => {
            state.loading=false;
        } ,

        [ getById.pending ] : ( state , action ) => {
            state.loading=true;
        } ,
        [ getById.fulfilled ] : ( state , action ) => {
            state.data=action.payload;
            state.loading=false;
        } ,
        [ getById.rejected ] : ( state , action ) => {
            state.loading=false;
        } ,

        [ update.pending ] : ( state , action ) => {
            state.loading=true;
        } ,
        [ update.fulfilled ] : ( state , action ) => {
            state.data=action.payload;
            state.loading=false;
        } ,
        [ update.rejected ] : ( state , action ) => {
            state.loading=false;
        } ,

        [ save.pending ] : ( state , action ) => {
            state.loading=true;
        } ,
        [ save.fulfilled ] : ( state , action ) => {
            state.data=action.payload;
            state.loading=false;
        } ,
        [ save.rejected ] : ( state , action ) => {
            state.loading=false;
        } ,

        [ remove.pending ] : ( state , action ) => {
            state.loading=true;
        } ,
        [ remove.fulfilled ] : ( state , action ) => {
            state.data=action.payload;
            state.loading=false;
        } ,
        [ remove.rejected ] : ( state , action ) => {
            state.loading=false;
        } ,


    }
} )

export const mapPeriodeDaftarSelector = (state) => state.mapPeriodeDaftar;
export default mapPeriodeDaftarSlice.reducer;